<p-table
  #dt
  [value]="listaCommon"
  [rowHover]="true"
  (onLazyLoad)="ordinamento($event)"
  [customSort]="true"
  [lazy]="true"
  [sortField]="orderColumnName"
  [sortOrder]="orderCustom(order)"
>
  <!-- headers -->
  <ng-template pTemplate="header">
    <tr>
      @for(headerName of headersTabella; track $index){
        <th
          [pSortableColumn]="headerName === 'Stato' ? '' : rowsTabella[$index]"
        >
          {{ headerName }}
          @if(headerName !== 'Stato'){
            <p-sortIcon [field]="rowsTabella[$index]"></p-sortIcon>
          }
        </th>
      }
    </tr>
  </ng-template>

  <!-- rows -->
  <ng-template pTemplate="body" let-iscritto>

    <tr style="cursor: pointer;" [routerLink]="generaRoutingLink(iscritto)">

      @for (rowName of rowsTabella; track $index) {

        @if (rowName === 'statoIscritto') {
          <td class="font-bold" [style.color]="coloreStato(iscritto.statoIscritto)">
            {{ iscritto.statoIscritto.nome }}
          </td>
        }@else{
          <td>{{ iscritto[rowName] }}</td>
        }

      }
    </tr>
  </ng-template>
</p-table>
